import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormItemProps as AntFormItemProps,
  FormProps as AntFormProps
} from 'antd';
import * as Styled from './styles';

type FormProps = Omit<AntFormProps, 'children'> & {
  children: ReactNode;
};

type FormItemProps = AntFormItemProps & {
  isRequiredHidden?: boolean;
  isWhitespaceForbidden?: boolean;
};

export const Form: FC<FormProps> = props => {
  return <Styled.FormComponent {...props} />;
};

export const FormItem: FC<FormItemProps> = props => {
  const { t } = useTranslation();
  // If isWhitespaceForbidden prop is passed then add the whitespace rule
  const rulesWithWhiteSpaceRule =
    props.rules && props.isWhitespaceForbidden
      ? [
          ...props.rules,
          { whitespace: true, message: t('generic.blankFieldError') }
        ]
      : props.rules;
  const allRules = props.rules ? rulesWithWhiteSpaceRule : [];
  const mergedProps = {
    ...props,
    rules: allRules
  };
  return (
    <Styled.FormComponent.Item
      {...mergedProps}
      className={props.isRequiredHidden ? 'required-hidden' : ''}
    />
  );
};

export const useForm = Styled.FormComponent.useForm;
export const useWatch = Styled.FormComponent.useWatch;
